/* eslint-disable */
export default {
  _balooregular: 'balooregular',
}